import { StyleSystemProps } from '@withjoy/joykit';

export const AppsWrapperStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: ['column', 'row'],
  justifyContent: [null, 'center'],
  alignItems: ['center', null],
  paddingBottom: 8,
};
